import { environment } from 'src/environments/environment';

export const openOnboardingInNewTab = (key: string, lang: string): void => {
  window.open(`${environment.blappWeb}/onboarding?key=${key}&lang=${lang}`, '_blank');
};
